import React, { useContext } from 'react'
import {
    Box,
    Stack,
} from '@mui/material'

import Header from './../../utils/header.js'
import { AppContext } from './../../context/context/context.js'

import data from './../../data/skills.json'
import { assets } from './assets.js'

const Skills = () => {
    const { state } = useContext(AppContext)

    return (
        <Box textAlign={"center"}>
            <Header color={state.color.light} title='SKILLS' />
            <Stack
                data-aos="fade-up"
                direction={{ xs: 'row' }}
                justifyContent="center"
                alignItems={"center"}
                spacing={{ xs: 1, sm: 2, md: 4 }}
            >
                {data.map((skill, index) =>
                    <Box
                        width={80}
                        px={2}
                        key={index}
                        component={"img"}
                        src={assets(skill.image)}
                        alt={skill.name}
                    />
                )}
            </Stack >
        </Box >
    )
}

export default Skills
